<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <v-img src="https://i.imgur.com/6ZLGuNi.jpg" max-height="80vh" contain></v-img>
      </v-col>
      <v-col cols="6">
        <div class="text-h2">Page Not Found</div>
        <div class="text-h4">Looks like the page you're looking for either doesn't exist, or hasn't been built yet!</div>
        <v-btn @click="goBack">Take me back to where I was!</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

    export default {
      name: 'underConstruction',
      data: () => ({

      }),
      methods: {
        goBack() {
          this.$router.go(-1)
        }
      },
    }
</script>